import PARENT from '../types';

const SAMPLES = `${PARENT}/SAMPLES`;

export const SET_SAMPLES = `${SAMPLES}/SET`;
export const RESET_SAMPLES = `${SAMPLES}/RESET`;
export const APPEND_SAMPLES = `${SAMPLES}/APPEND`;

export default SAMPLES;
